interface InventoryUIDetailsProps {
  data: {
    Subheader: string;
    Headline: string;
    HeroImage: {
      Url: string;
    };
  };
  isLoaded: boolean;
}

export const initialInventoryUIDetails: InventoryUIDetailsProps = {
  data: {
    Subheader: "",
    Headline: "",
    HeroImage: {
      Url: "",
    },
  },
  isLoaded: false,
};

export const initialReducer = (
  state = initialInventoryUIDetails,
  { type, payload }: { type: string; payload: any },
) => {
  switch (type) {
    case "SET_INITIAL_DATA":
      return {
        ...state,
        data: payload,
      };
    case "TOGGLE_LOADING":
      return {
        ...state,
        isLoaded: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};
